import { useSettingsStore } from '@/store';
import { web3Config } from '@/configs/web3-config';

export const useWeb3Config = () => {
  const settings = useSettingsStore(state => state.settings);
  return web3Config(settings);
};